import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export const OTSQuote = (props) => (
  <div className={"collabs-banner-quote ots-fg tile is-5"}>
    {`“The patterns take on a new life when filtered through the specific nature of the weave. A once everyday, universal material can be experienced anew.”`}
    {/* <div className={"collabs-banner-byline"}>
      —LAUN Los Angeles
    </div> */}
    <a className={"collabs-banner-button"} href={"https://www.stitchroom.com/fabrics"}><p>Upholster with </p><img src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-hp/stitchroom.png", 600)} /></a>
  </div>
);

export const OTSBio = (props) => (
  <div className={"collabs-bio"}>
    <div className={"collabs-divider ots-bg"} />

    <div className={"collabs-section white white tile is-ancestor"}>
      <div className={'collabs-bio-image-container tile is-5'}>
        <img className={"collabs-bio-image"} alt={"Office of Tangible Space"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/ots/OTS_Bio_01.jpg", 1000)} />
      </div>
      <div className={"collabs-bio-header tile is-5 margin-left-36"}>
        <h1>Office of Tangible Space - Organic Observations Collection</h1>
        <p>Office of Tangible Space is an interdisciplinary design studio based in New York and San Francisco founded by Michael Yarinsky and Kelley Perumbeti that specializes in architecture, interiors, furniture and curation.</p>
      </div>
    </div>

    <div className={"collabs-section grey"}>
      <div className={"bio-content"}>
        <p>Our collection of textiles designed by Office of Tangible Space is a reinterpretation of the mundane. Taking on the role of observers and manipulators, they embarked on a process of understanding the properties of select natural materials. They explored the coast, forest, and field and found materials and mediums that offered varied perspectives through physical manipulation, photography and digital abstraction. Through these processes certain qualities became apparent - array and disarray, integration and disintegration and different readings of pattern when scale is modified. When filtered through the specific nature of the weave, the patterns take on a new life. A once everyday, universal materials can be experienced anew when viewed through this new lens.</p>

        <p>Their work is grounded in a human-centric approach that is achieved through warmth and materiality - the creation of objects and spaces that cultivate a feeling of comfort and contentment. Much of the work attempts to bring in play and engagement through form, texture, through the use of new and unexpected materials, details and color. Office of Tangible Space likes to create unexpected moments of interaction. The designs seek to be aesthetically appealing, yes, but hope to make you feel something. Regardless of project scale, the intentionality in each detail of their work allows for moments of thoughtful engagement.</p>

      </div>
    </div>
  </div>
);
